import format from 'date-fns/format';

const DateOnlyFilter = (value, pattern = 'yyyy-MMM-dd') => {
    if (!value) return '';

  let [year, month, day] = value.substr(0, 10).split('-');

  try { return format(new Date(year, (month - 1), day), pattern); }
  catch { return value; }
}

export { DateOnlyFilter };
